import React from 'react';
import { ADivider, ADividerOrientation } from '../../atoms/ADivider/index';
import { MButton } from '../MButton/index';
import { MButtonType, MButtonSize, MButtonIconPlacement } from '../MButton/MButton.types';
import { MBreadcrumb } from '../MBreadcrumb/index';
import { MBreadcrumbGroupProps } from './MBreadcrumbGroup.types';
import * as Styled from './MBreadcrumbGroup.styles';

const DEFAULT_BACK_BUTTON_TEXT = 'Back';

export const MBreadcrumbGroup: React.FC<MBreadcrumbGroupProps> = ({ backButton, mButton, mBreadcrumbMulti }) => {
  const numberOfItems = mBreadcrumbMulti?.length ?? 0;
  return (
    <Styled.BreadcrumbGroupWrapper>
      {backButton && (
        <>
          <MButton
            variant={MButtonType.Tertiary}
            size={MButtonSize.M}
            iconPlacement={MButtonIconPlacement.Leading}
            iconClass="icon-back-arrow"
            buttonText={mButton?.buttonText || DEFAULT_BACK_BUTTON_TEXT}
          />
          {numberOfItems > 0 && <ADivider orientation={ADividerOrientation.Vertical} />}
        </>
      )}
      {numberOfItems > 0 &&
        mBreadcrumbMulti.map((item, idx) => <MBreadcrumb key={idx} {...item} isLast={idx === numberOfItems - 1} />)}
    </Styled.BreadcrumbGroupWrapper>
  );
};
